import { Navigate, useLocation } from 'react-router-dom'
import { Suspense } from 'react'

// ** Spinner
import Spinner from '@components/spinner/Loading-spinner'
import { saveReturnUrl, clearAuthSession } from '@src/utility/authRedirect'

// ** Decode JWT
function decodeJWT(token) {
  try {
    if (!token) throw new Error('No token provided')

    const parts = token.split('.')
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format')
    }

    const payload = parts[1]

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')

    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      '='
    )

    const decoded = atob(padded)

    return JSON.parse(decoded)
  } catch (error) {
    console.error('Invalid JWT:', error.message)
    return null
  }
}

// ** Check if token expired
function isTokenExpired(token) {
  const decoded = decodeJWT(token)

  if (!decoded || !decoded.exp) return true

  const currentTime = Math.floor(Date.now() / 1000)

  return decoded.exp < currentTime
}

const PrivateRoute = ({ children, route }) => {
  const user = JSON.parse(localStorage.getItem('userData'))
  const accessToken = localStorage.getItem('accessToken')
  const refreshToken = localStorage.getItem('refreshToken')
  const location = useLocation()

  const fullLocation = {
    pathname: location.pathname,
    search: location.search,
    hash: location.hash
  }

  // ** If user not logged in
  if (!user || !accessToken) {
    saveReturnUrl(`${location.pathname}${location.search}${location.hash}`)
    clearAuthSession()
    return <Navigate to="/login" state={{ from: fullLocation }} replace />
  }

  // ** Check accessToken
  const accessExpired = isTokenExpired(accessToken)

  if (accessExpired) {
    if (!refreshToken || isTokenExpired(refreshToken)) {
      saveReturnUrl(`${location.pathname}${location.search}${location.hash}`)
      clearAuthSession()
      return <Navigate to="/login" state={{ from: fullLocation }} replace />
    }
  }

  if (route) {
    let restrictedRoute = false

    if (route.meta) {
      restrictedRoute = route.meta.restricted
    }

    if (user && restrictedRoute) {
      return <Navigate to="/" replace />
    }
  }

  return <Suspense fallback={<Spinner fullPage />}>{children}</Suspense>
}

export default PrivateRoute
